exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-data-table td {\n  word-break: break-all;\n}\n.v-data-table {\n  overflow: hidden;\n}\n", ""]);

// exports
